<template>
    <div class="position-box">
      <div class="head">
        <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
        <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
        <div class="title">Verification code</div>
      </div>
      <div class="cotainer">
        <div class="code-box">
          <div class="title">ASSET(USDT)</div>
          <div class="money">3589.0000</div>
          <div class="tips">address</div>
          <div class="input-box">
            <input class="input" type="text" v-model="address" placeholder="" autocomplete="off">
            <div class="copy" @click="copy($event)">Copy</div>
          </div>
          <div class="tips">encode</div>
          <div class="input-box">
            <input class="input" type="text" v-model="code" placeholder="" autocomplete="off">
          </div>
        </div>
        <div class="btn-sure" @click="next">Next</div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'verification',
    data () {
        return {
          theme: false,
          address: '',
          code: ''
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {

    },
    methods: {
      goBack(){
        this.$router.push('/capital')
      },
      next(){
        this.$router.push('/results')
      },
      copy(e){
        let address = this.address;
        this.$copyText(address, this.$t('kjmb.fzcg'));
        this.$toast.center(this.$t('kjmb.fzcg'));
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
     .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #f3f3f3;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .32rem;
        background: #f3f3f3;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .code-box{
      margin-top: 1.2rem;
      padding: 0 .46rem 1.08rem .58rem;
      color: #000;
      border-radius: .2rem;
      background: #fff;
    }
    .code-box .title{
      padding: .9rem 0 .82rem;
      font-size: .34rem;
      text-align: center;
    }
    .code-box .money{
      font-size: .75rem;
      text-align: center;
    }
    .code-box .tips{
      position: relative;
      margin: .35rem 0 .8rem;
      padding-left: .3rem;
      font-size: .48rem;
    }
    .code-box .tips::before{
      position: absolute;
      left: 0;
      top: 50%;
      content: '';
      width: .05rem;
      height: .41rem;
      background: #689ee8;
      transform: translateY(-50%);
    }
    .code-box .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 1.24rem;
      padding: 0 .28rem 0 .45rem;
      background: #f4f4f4;
      border-radius: 0.2rem;
    }
    .code-box .input{
      flex: 1;
      color: #343434;
      font-size: .4rem;
    }
    .code-box .copy{
      margin-left: .28rem;
      padding: .1rem .6rem;
      color: #fff;
      font-size: .34rem;
      background: #4458ed;
	    border-radius: 0.1rem;
    }
    .btn-sure{
      width: 10.14rem;
      height: 1.32rem;
      margin: 1.36rem auto 0;
      color: #fff;
      font-size: .56rem;
      line-height: 1.32rem;
      background: #4458ed;
      border-radius: 0.66rem;
      border: 1px solid #e4e4e4;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/capital/verification.vue